module.exports = __webpack_public_path__ + "img/section17.477dffbb.png";